import React, { Component } from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import VisibilitySensor from 'react-visibility-sensor';
import TitleUnderlined from '../../components/TitleUnderlined';
import convertHtml from '../../utils/convertHtml';

const PrivacyContainer = styled.div``;

const LegalContainer = styled.div``;

const MasterContainer = styled.div`
  display: flex;
  @media (max-width: 1000px) {
    flex-wrap: wrap;
  }
`;

const ContentsContainer = styled.div`
  width: 100%;
  height: fit-content;
  position: sticky;
  top: 160px;
  margin-left: 250px;
  @media (max-width: 1440px) {
    margin-left: 150px;
  }
  @media (max-width: 1265px) {
    margin-left: 50px;
  }
  @media (max-width: 1000px) {
    position: inherit;
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
  }
`;

const ContentsContainerOuter = styled.div`
  margin-top: 60px;
  padding-bottom: 60px;
  width: 550px;
  @media (max-width: 1000px) {
    width: 100%;
    padding: 0px;
  }
`;

const ContentContainer = styled.div`
  margin-left: 100px;
  margin-top: 125px;
  @media (max-width: 1440px) {
    margin-left: 50px;
    padding-right: 50px;
  }
  @media (max-width: 1100px) {
    padding-right: 25px;
    margin-left: 25px;
  }
  @media (max-width: 1000px) {
    position: inherit;
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    padding: 0;
    margin-top: 40px;
  }
`;

const ContentsItem = styled.a`
  max-width: 300px;
`;

const ItemContainer = styled.div`
  max-width: 900px;
  margin-bottom: 67px;
  margin-top: 67px;
  scroll-margin: 180px;
  @media (max-width: 1000px) {
    scroll-margin: 50px;
    margin-top: 0px;
    margin-bottom: 30px;
    max-width: 100%;
  }
`;

const Title = styled.h2`
  font-family: DM Serif Text;
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 36px;
  color: #404040;
  @media (max-width: 1000px) {
    margin-bottom: 10px;
  }
`;

const Paragraph = styled.div`
  font-family: DM Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 180%;
  letter-spacing: 0.01em;
  color: #404040;
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const ContentsItemContainerOuter = styled.div`
  width: 100%;
`;

const NumContainer = styled.a`
  font-family: DM Sans;
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 36px;
  color: #404040;
  padding-right: 10px;
  margin-top: -1px;
`;

const ContentsTextContainer = styled.a`
  font-family: DM Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 36px;
  color: #404040;
  word-break: break-word;
  max-width: 350px;
  @media (max-width: 1000px) {
    max-width: 100%;
  }
`;

const ContentsItemInner = styled.div`
  display: flex;
`;

const ScrollLink = styled.a`
  scroll-margin: 180px;
  @media (max-width: 1000px) {
    scroll-margin: 100px;
  }
`;

const TitleContainer = styled.div`
  margin-bottom: 20px;
`;

const LastUpdated = styled.div`
  font-family: DM Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #aaaaaa;
  margin-bottom: 50px;
`;

export class Privacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      visible: false,
      visibilitySensorActive: true,
    };
  }

  handleVisibilityChange = visible => {
    if (this.state.visible !== visible) {
      this.setState({ visible, visibilitySensorActive: !visible });
    }
  };
  render() {
    return (
      <VisibilitySensor
        active={this.state.visibilitySensorActive}
        onChange={this.handleVisibilityChange}
        partialVisibility
        minTopValue={250}
      >
        <PrivacyContainer>
          <MasterContainer>
            <ContentsContainerOuter>
              <ContentsContainer>
                <TitleContainer>
                  <TitleUnderlined
                    underlineColor={this.props.color_theme}
                    textColor={'#ffffff'}
                    fontSize={'36px'}
                    titleText={
                      '<span>' + this.props.privacySectionName + '</span>'
                    }
                  />
                </TitleContainer>
                <LastUpdated>
                  {this.props.privacySectionLastUpdated}
                </LastUpdated>
                <ItemsContainer>
                  {this.props.privacySections.map((item, index) => {
                    let id =
                      '#' +
                      item.section_title[0].text
                        .toLowerCase()
                        .replace(/\s/g, '')
                        .replace(/[0-9]/g, '')
                        .replace(/[^a-zA-Z ]/g)
                        .split('.')
                        .join('');
                    let num = index + 1;
                    return (
                      <ContentsItemContainerOuter>
                        <ContentsItem>
                          <ContentsItemInner>
                            <NumContainer href={id}>{num}</NumContainer>
                            <ContentsTextContainer
                              href={id}
                              color={this.props.color_theme}
                            >
                              {item.section_title[0].text}
                            </ContentsTextContainer>
                          </ContentsItemInner>
                        </ContentsItem>
                      </ContentsItemContainerOuter>
                    );
                  })}
                </ItemsContainer>
              </ContentsContainer>
            </ContentsContainerOuter>
            <ContentContainer>
              {this.props.privacySections.map((item, index) => {
                let id = item.section_title[0].text
                  .toLowerCase()
                  .replace(/\s/g, '')
                  .replace(/[0-9]/g, '')
                  .replace(/[^a-zA-Z ]/g)
                  .split('.')
                  .join('');
                let num = index + 1;
                return (
                  <ItemContainer>
                    <ScrollLink name={id} id={id}></ScrollLink>
                    <Title>
                      {num}. {item.section_title[0].text}
                    </Title>
                    {item.section_paragraph.map((paragraph, paraIndex) => {
                      if (paraIndex === item.section_paragraph.length - 1) {
                        return (
                          <Paragraph
                            dangerouslySetInnerHTML={convertHtml(
                              paragraph.text
                            )}
                          />
                        );
                      } else {
                        return (
                          <div>
                            <br></br>
                            <Paragraph
                              dangerouslySetInnerHTML={convertHtml(
                                paragraph.text
                              )}
                            />
                          </div>
                        );
                      }
                    })}
                  </ItemContainer>
                );
              })}
            </ContentContainer>
          </MasterContainer>
        </PrivacyContainer>
      </VisibilitySensor>
    );
  }
}

export default Privacy;
